// eslint max-len: 0
const messages = {
  'about.title': 'Diedut - Varaamo bálvalusa birra',
  'app.about': 'Diedut',
  'app.login': 'Cálit sisa',
  'app.logout': 'Cálit olggos',
  'app.my_reservations': 'Mu várrejumit',
  'app.search': 'Oza',
  'home.title': 'Ruovttoluotta - Varaamo',
  'home.what_purpose': 'Maid don háliidat bargat?',
  'imagepanel.images': 'Govat',
  'login.back': 'Ruovttoluotta',
  'login.login': 'Cálit sisa',
  'login.login_and_save': 'Cálit sisa ja vurke',
  'login.password': 'PIN',
  'login.modal_title': 'Cálit sisa',
  'login.username': 'Girjerádjogoartta nummár',
  'multiday.begin': 'Álgá',
  'multiday.cancel': 'Šluhtte',
  'multiday.end': 'Nohká',
  'multiday.header': 'Daga várrejumi má?ga beaivái',
  'myreservations.no_ordinary': ' Eai jeavddalaš várrejumiid maid cájehit.',
  'myreservations.no_preliminary': 'Eai ovddalgihtii várrejumiid maid cájehit.',
  'myreservations.ordinary_reservations': 'Jeavddalaš várrejumit',
  'myreservations.page_header': 'Mu várrejumit',
  'myreservations.preliminary_reservations': 'Ovddalgihtii várrejumit',
  'myreservations.title': 'Mu várrejumit - Varaamo',
  'notfound.title': '404 Siidu ii gávdno - Varaamo',
  'ResourceAvailability.available': 'Lea dál oažžumis',
  'ResourceAvailability.availableAt': 'Lea friddja {time}',
  'ResourceAvailability.closed': 'Giddejuvvon',
  'ResourceAvailability.reserved': 'Várrejuvvon olles beaivái',
  'reservation.accept': 'Dohkkehuvvon',
  'reservation.all': 'Buot',
  'reservation.cancel': 'Šluhtte',
  'reservation.edit': 'Divo',
  'reservation.information': 'Diedut',
  'reservation.reject': 'Hilggo',
  'reservation.reservation_status': 'Várrejumi dilli',
  'reservation_calendar.back': 'Ruovttoluotta',
  'reservation_calendar.choose_time': 'Vállje várrejumi áigodaga',
  'reservation_calendar.confirm_changes': 'Nanne divvuma',
  'reservation_calendar.go_to_selected': 'Sirddaš válljejupmái',
  'reservation_calendar.reserve': 'Várre',
  'reservation_calendar.reserving': 'Várremin...',
  'reservation_calendar.saving': 'Vurkemin...',
  'reservation_calendar.today': 'Odne',
  'reservation_cancel.are_you_sure': `Leatgo sihkkar ahte háliidat šluhttet {num, plural,
      one {várrejumi}
      other {várrejumit}
      }:`,
  'reservation_cancel.back': 'Ruovttoluotta',
  'reservation_cancel.by_contact': `Dán várrejumi galgá šluhttet girjerádjobargi bokte. Jus
   háliidat šluhttet várrejumi dahje rievdat várrejumi áiggi, váldde oktavuoda girjerádjobargiin.`,
  'reservation_cancel.cancel': 'Šluhtte várrejumi',
  'reservation_cancel.canceling': 'Šluhtteme...',
  'reservation_cancel.do_not_cancel': 'Ale šluhtte várrejumi',
  'reservation_cancel.titleConfirm': 'Nanne šluhttema',
  'reservation_cancel.titlePreliminary': 'Šluhtte várrejumi',
  'reservation_form.address': 'Cujuhus',
  'reservation_form.address_city': 'Báikegoddi',
  'reservation_form.address_street': 'Lágášcujuhus',
  'reservation_form.address_zip': 'Zip kodá',
  'reservation_form.back': 'Ruovttoluotta',
  'reservation_form.billing_address': 'Rehkega cujuhus',
  'reservation_form.comments': 'Kommeantat',
  'reservation_form.comments_help': 'Várrejumi molssaeavttut',
  'reservation_form.enter_valid_email': 'Cálit sisa iežat email- cujuhusain ',
  'reservation_form.event_description': 'Dáhpáhusa sisdoallu',
  'reservation_form.field_max_length': 'Cállinmearkkaid stuorimus mearri.',
  'reservation_form.must_accept_terms': `Don berret várrejumi oktavuodas dohkkehit
   geavahaneavttuid.`,
  'reservation_form.number_of_participants': 'Oasseváldimearri',
  'reservation_form.read_terms': 'Lean lohkan ja dohkkehan geavahaneavttuid.',
  'reservation_form.required_field': 'Dárbbašlaš diedut',
  'reservation_form.reserver_email': 'Email',
  'reservation_form.reserver_id': 'ALV ID / Riegádanbeaivi',
  'reservation_form.reserver_name': 'Várrejeaddji / Láigoheaddji',
  'reservation_form.reserver_phone_number': 'Telefovdna',
  'reservation_form.save': 'Vurke',
  'reservation_form.saving': 'Vurkeme...',
  'reservation_form.staff_event': 'Girjerádjobargi várrejupmi',
  'reservation_form.staff_event_help': `Girjerádjobargiid várrejumit leat automáhtalaccat
   dohkkehuvvon dallego lea almmuhan iežas nama ja dáhpáhusa dieduid.`,
  'reservation_info.address': 'Cujuhus:',
  'reservation_info.back': 'Ruovttoluotta',
  'reservation_info.billing_address': 'Rehkega cujuhus:',
  'reservation_info.comments': 'Kommeanta:',
  'reservation_info.comments_help': 'Molssaevttolaš várrendiedut',
  'reservation_info.event_description': 'Dáhpáhusa diedut:',
  'reservation_info.help_title': 'Várrenrávvagat',
  'reservation_info.login_required': 'Don berret cálihit iežat sisa vai basttat várrejumi dahkat.',
  'reservation_info.max_period': `Guhkimus várrenáigodat dáhkamii dárbbašlaš diedut :{days, plural,
            =0 {} one {\u00a0# beaivi} other {\u00a0# beaivvit}}{hours, plural,
            =0 {} one {\u00a0# diibmu} other {\u00a0# diimmut}}{minutes, plural,
            =0 {} one {\u00a0# minuhtta} other {\u00a0# minuhtat}}.`,
  'reservation_info.max_per_user': 'Stuorimus várrenmearri ovtta várrejeaddjái: {amount}',
  'reservation_info.number_of_participants': 'Oasseváldiid mearri:',
  'reservation_info.reservable_after_days': ` Várrejumi galgá dahkat {days} {days, plural,
                                              one {beaivi} other {beaivvit}} ovddalgihtii.`,
  'reservation_info.reservation_time': 'Várrenáigi',
  'reservation_info.reservation_info': 'Várrejumi diedut',
  'reservation_info.reserver_email': 'Email:',
  'reservation_info.reserver_id': 'ALV ID / Riegádanbeaivi',
  'reservation_info.reserver_name': 'Várrejeaddji / Láigoheaddji',
  'reservation_info.reserver_phone_number': 'Telefovdna:',
  'reservation_info.resource': 'Latnja:',
  'reservation_info.save': 'Vurke',
  'reservation_info.saving': 'Vurkeme...',
  'reservation_list.no_reservations': 'Dus eai leat várrejumit.',
  'reservation_modal.confirm_help': `Leatgo sihkkar ahte háliidat várret {num, plural,
      one {várrejumi}
      other {várrejumit}
      }:`,
  'reservation_modal.editing_after': 'Ma??el rievdademiid:',
  'reservation_modal.editing_are_you_sure': `Leatgo sihkkar ahte háliidat
  rievdadit iežat várrejumi?`,
  'reservation_modal.editing_before': 'Ovdal rievdademiid:',
  'reservation_modal.preliminary_form_help': `Cále cuovvovaš dieduid. 
                                              Gáibiduvvon diedut leat merkejuvvon násttiin (*)`,
  'reservation_modal.preliminary_help': `Leat dahkame {num, plural, 
      one {vuosttáš várrejumi}
      other {vuosttáš várrejumit}
      }:`,
  'reservation_modal.title_confirm': 'Nanne várrejumi',
  'reservation_modal.title_editing': 'Nanne divodemiid',
  'reservation_modal.title_preliminary': 'Ovddalgihtii várrejupmi',
  'reservation_page.reservation_status_title': 'Várrejumi dilli',
  'reservation_page.reserve_title': 'Várre',
  'reservation_page.resource_info': 'Dárkilut diedut',
  'reservation_page.title': '{resourceName}  Várrenkaleandar - Varaamo',
  'reservation_success.info_email': `Lassediedut ovddalgihtii várrejumis sáddejuvvojit
  email- cujuhussii mii lea almmuhuvvon várrejumi oktavuodas.`,
  'reservation_success.made_preliminary': `Leat dahkan ovddalgihtii várrejumi báikái {name}
      áigái  {times, plural, one {áigi} other {áiggit} }:`,
  'reservation_success.sent': 'Du várrejupmi lea sáddejuvvon',
  'resource.image_alt': 'Govva {resourceName}',
  'resource.reservation_status': 'Várrejumi dilli',
  'resource.reserve': 'Várre',
  'resource.title': '{resourceName} - Varaamo',
  'search.help_text': 'Oza bálvalusa/báikki ohcansániiguin.',
  'search.no_results': 'Du ohcan ii gávdnon.',
  'search.page_header': 'Oza',
  'search.title': 'Oza - Varaamo',
  'search_controls.go_to_selected': 'Mana válljejupmái',
  'search_controls.search': 'Oza',
  'search_controls.today': 'Odne',
  'search_filters.purpose': 'Rusttegat, báikkit ja bálvalusat',
  'search_filters.unit': 'Girjerájus',
  'search_result.details': 'Dárkilut diedut',
  'search_result.hours_available': `{hours, plural,
      one {# diibmu}
      other {# diimmut}
      } friddja`,
  'search_result.reserve': '. Várre.',
  'timerange.timestring': 'at {begin} \u2013 {end}',
  'timeslot.editing': 'Divodeame',
  'timeslot.free': 'Friddja',
  'timeslot.login_to_reserve': 'Cálit iežas sisa vai beasat várrejumi dahkat.',
  'timeslot.not_reservable': 'Ii várrenláhkái',
  'timeslot.reserved': 'Várrejuvvon',
  'timeslots.comments': 'Kommeanta',
  'timeslots.functions': 'Doaimmat',
  'timeslots.not_reservable_today': 'Eai gávdno friddja várrenáiggit válljejuvvon beaivái.',
  'timeslots.reserver': 'Várrejuvvon',
  'timeslots.status': 'Dilli',
  'timeslots.time': 'Áigi',
};

export default messages;



/** WEBPACK FOOTER **
 ** ./app/messages/sme.js
 **/